module.exports = __webpack_public_path__ + "static/emo-bro-085ce9cbdf0a46d082f94b56319715d1.gif";